import React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import { isPositiveNumber } from "et3-type-guards";
import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../../core/et3-page-div";
import Et3PageTitle from "../../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../../stores/core/core-history-store";
import getCoreUIStore from "../../../../stores/core/core-ui-store";
import getKhattabatMatchingStore from "../../../../stores/khattabat-stores/matching-stores";
import getKhattabat101MGeneralStore from "../../../../stores/khattabat-stores/101m-stores/general-101m-store";
import KhattabatBulkMessages from "../../khattabat-clients/bulk-messages/KhattabatBulkMessages";
import PaidUserSelect from "../search-and-101m/form/PaidUserSelect";
import KhattabatMatchConversations from "./101m-conversations/KhattabatMatchConversations";
import KhattabatResultsFilters from "./form/KhattabatResultsFilters";
import KhattabatResultsSelectionBar from "./form/KhattabatResultsSelectionBar";

const KhattabatResults = withLiteObserverAndTheme((props) => {
  const { unitX } = props.theme;
  const isLoading = getCoreUIStore().isPageLoading.get(
    "KHATTABAT_MATCHING_RESULTS"
  );
  const hasPaidUser = isPositiveNumber(
    getKhattabatMatchingStore().currentClientInformation.get().userId
  );

  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "KHATTABAT_MATCHING_RESULTS",
      "KHATTABAT_MATCHING_RESULTS"
    );
    getKhattabatMatchingStore().getPaidUsersInformation();
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{ position: "relative" }}
    >
      <Et3PageTitle
        title={i18n.get("KHATTABAT_MATCHING_RESULTS")}
        subTitle={""}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Stack
        spacing={2}
        sx={{ alignSelf: "stretch", pb: 2, pr: `${40 * unitX}px` }}
      >
        <PaidUserSelect
          showCount
          action={
            <Button
              variant="contained"
              disabled={!hasPaidUser || isLoading}
              startIcon={
                isLoading ? (
                  <CircularProgress size={16} color="inherit" />
                ) : undefined
              }
              onClick={async () => {
                getKhattabat101MGeneralStore().resetClientConversations();
                await getKhattabat101MGeneralStore().getMatchesConversations();
              }}
              sx={{ whiteSpace: "nowrap" }}
            >
              {i18n.get("GET_CONVESATIONS")}
            </Button>
          }
        />
        <KhattabatResultsFilters />
        <KhattabatResultsSelectionBar />
        <KhattabatMatchConversations />
        <KhattabatBulkMessages conversationType="101M" />
      </Stack>
    </ET3PageDiv>
  );
});
export default KhattabatResults;
